<ng-container *transloco="let t;">
    <div class="container d-flex justify-content-center align-items-center">
        <div class="w-100 py-4" style="max-width: 40rem;">
            <breadcrumb [items]='[{ label: t("header.frontpage"), route: "/"}, { label: t("header.clinicnavtitle")} ]'></breadcrumb>
            <div class="content-box p-4">
                <h3 class="card-title mb-3">{{ t("clinicprofile.title") }}</h3>
                <form class="row g-3">
                    <div class="col-md-6">
                        <label for="username" class="col-form-label fw-bold">{{ t("clinicprofile.username") }}</label>
                        <p>{{clinicInfo?.userName}}</p>
                    </div>
                    <div class="col-md-6">
                        <label for="firstname" class="col-form-label fw-bold">{{ t("clinicprofile.organisationname") }}</label>
                        <p>{{clinicInfo?.organizationName}}</p>
                    </div>

                    <div class="col-md-6">
                        <label for="locationNumber" class="col-form-label fw-bold">{{ t("clinicprofile.locationnumber")
                            }}</label>                        
                            <p>{{clinicInfo?.locationNumber}}</p>
                    </div>
                    <div class="col-md-6">
                        <label for="ydernummer" class="col-form-label fw-bold">{{ t("clinicprofile.providernumber") }}</label>                        
                            <p>{{clinicInfo?.providerNumber}}</p>
                    </div>

                    <div class="col-12">
                        <div class="form-check">
                            <input class="form-check-input" type="checkbox" id="notifications" [formControl]="sendEdi">
                            <label class="form-check-label" for="notifications">
                                {{ t("clinicprofile.edinotifications") }}
                            </label>
                        </div>
                        <i class="text-muted">{{ t("clinicprofile.edinotificationremark") }}</i>
                    </div>
                </form>
            </div>
        </div>
    </div>
</ng-container>